<template>
  <div class="bid-policy container">
    <h1 class="font-bold mb-32">{{ $t('bidPolicy.title') }}</h1>
    <div class="px-16 py-12">
      <ul class="list-reset text-base" style="line-height: 24px">
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.1.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.1.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.2.subTitle') }}
          </div>
          <span v-html="$t('bidPolicy.content.2.desp')" />
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.3.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.3.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.4.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.4.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.5.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.5.desp') }}
          <ul class="px-24" style="list-style-type: disc;">
            <li v-for="text in $t('bidPolicy.content.5.list')" :key="text">{{ text }}</li>
          </ul>
          <div class="bg-grey-lightest font-medium mt-16 p-8 text-xs text-grey-darker flex items-center" style="background: rgb(248, 250, 252); border-radius: 20px">
            <i class="owl-status-triangle-warning text-orange text-2xl pr-4" />
            <span class="text-xs" style="line-height: 20px;">{{ $t('bidPolicy.content.5.warning') }}</span>
          </div>
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.6.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.6.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.7.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.7.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.8.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.8.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.9.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.9.desp') }}
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.10.subTitle') }}
          </div>
          <ul class="px-24" style="list-style-type: disc;">
            <li v-for="text in $t('bidPolicy.content.10.list')" :key="text">{{ text }}</li>
          </ul>
        </li>
        <li class="mb-40">
          <div class="text-lg font-bold mb-8">
            {{ $t('bidPolicy.content.11.subTitle') }}
          </div>
          {{ $t('bidPolicy.content.11.desp') }}
          <ul class="px-24" style="list-style-type: disc;">
            <li v-for="text in $t('bidPolicy.content.11.list')" :key="text">{{ text }}</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BidPolicy',
  metaInfo () {
    return {
      title: 'BidPolicy'
    }
  }
}
</script>

<style lang="sass">
.bid-policy
  @apply mt-32
</style>
